import { filterTypes } from '../../interfaces/sequencer/constants';
import { controllerValuesEqual } from '../../util/controllerValuesEqual';

const calculateEqScore = (activeInterface) => {
   const { correct: correctCount, checked: checkedCount } =
      activeInterface.instrumentRack.reduce(
         ({ correct, checked }, track) => {
            const updatedResults = {
               correct,
               checked,
            };

            for (
               let i = 0;
               i < track.referenceMixerTrack.effects[0].settings.bands.length;
               i++
            ) {
               const userBand = track.mixerTrack.effects[0].settings.bands[i];
               const referenceBand =
                  track.referenceMixerTrack.effects[0].settings.bands[i];

               // Check that filter type matches
               if (!userBand.type.disabled) {
                  updatedResults.checked += 1;
                  if (
                     userBand.type.value === referenceBand.type.value ||
                     // If gain is 0 and reference filter type is peak, highshelf, lowshelf; any of these filter types can count for good score.
                     (referenceBand.gain.value === 0 &&
                        [
                           filterTypes.peaking,
                           filterTypes.lowshelf,
                           filterTypes.highshelf,
                        ].includes(referenceBand.type.value) &&
                        [
                           filterTypes.peaking,
                           filterTypes.lowshelf,
                           filterTypes.highshelf,
                        ].includes(userBand.type.value))
                  ) {
                     updatedResults.correct += 1;
                  }
               }

               // If reference filter type is lowpass, highpass, notch, band pass; don't check gain
               if (
                  !userBand.gain.disabled &&
                  ![
                     filterTypes.lowpass,
                     filterTypes.highpass,
                     filterTypes.notch,
                     filterTypes.bandpass,
                  ].includes(referenceBand.type.value)
               ) {
                  updatedResults.checked += 1;
                  if (
                     ![
                        filterTypes.lowpass,
                        filterTypes.highpass,
                        filterTypes.notch,
                        filterTypes.bandpass,
                     ].includes(userBand.type.value)
                  ) {
                     updatedResults.correct += controllerValuesEqual(
                        userBand.gain.value,
                        referenceBand.gain.value
                     );
                  }
               }

               //  If gain is 0 and reference filter type is peak, highshelf, lowshelf don't check frequency
               if (
                  !userBand.detune.disabled &&
                  !(
                     referenceBand.gain.value === 0 &&
                     [
                        filterTypes.peaking,
                        filterTypes.lowshelf,
                        filterTypes.highshelf,
                     ].includes(referenceBand.type.value)
                  )
               ) {
                  updatedResults.checked += 1;
                  updatedResults.correct += controllerValuesEqual(
                     userBand.detune.value,
                     referenceBand.detune.value
                  );
               }

               //  If gain is 0 and reference filter type is peak, highshelf, lowshelf don't check Q
               // If reference filter type is lowshelf, highshelf; don't check Q
               if (
                  !userBand.Q.disabled &&
                  ![filterTypes.lowshelf, filterTypes.highshelf].includes(
                     referenceBand.type.value
                  ) &&
                  !(
                     referenceBand.gain.value === 0 &&
                     [
                        filterTypes.peaking,
                        filterTypes.lowshelf,
                        filterTypes.highshelf,
                     ].includes(referenceBand.type.value)
                  )
               ) {
                  updatedResults.checked += 1;
                  if (
                     ![filterTypes.lowshelf, filterTypes.highshelf].includes(
                        userBand.type.value
                     )
                  ) {
                     updatedResults.correct += controllerValuesEqual(
                        userBand.Q.value,
                        referenceBand.Q.value
                     );
                  }
               }
            }
            return updatedResults;
         },
         {
            correct: 0,
            checked: 0,
         }
      );

   return (correctCount / checkedCount) * 100;
};

export { calculateEqScore };
